import {
    ODataHeader,
    ODataString,
  } from "pbas-vue-components";
  
  const headers = [
    new ODataHeader({
      title: "globals.id",
      type: new ODataString("Id"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      title: "globals.name",
      type: new ODataString("Name"),
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "globals.description",
      type: new ODataString("Description"),
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
    }),
  ];
  export default headers;